module.exports = __webpack_public_path__ + "img/9788963011219.b2047d1d.jpg";